import { motion } from "framer-motion"
import type { ReactNode } from "react"
import logo from "../../assets/logo.png"

export default function AuthCard({
  title,
  subtitle,
  logoClassName = "h-16 w-auto",
  children,
}: {
  title: string
  subtitle: string
  logoClassName?: string
  children: ReactNode
}) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background bg-grid-pattern">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="w-full max-w-md"
      >
        <div className="gradient-card rounded-2xl border border-white/10 p-8 shadow-2xl">
          <div className="mb-8 flex flex-col items-center gap-4">
            <img src={logo} alt="Science Fitness" className={logoClassName} />
            <div className="text-center">
              <h1
                className="text-2xl font-bold tracking-widest text-primary glow-cyan-text uppercase"
                style={{ fontFamily: "var(--font-display)" }}
              >
                {title}
              </h1>
              <p className="mt-1 text-sm text-muted">{subtitle}</p>
            </div>
          </div>

          {children}
        </div>
      </motion.div>
    </div>
  )
}

export function AuthFormError({ error }: { error: string }) {
  if (!error) return null
  return (
    <motion.p
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="rounded-lg bg-danger/10 border border-danger/30 px-3 py-2 text-sm text-danger"
    >
      {error}
    </motion.p>
  )
}
